/* eslint-disable camelcase */
export const register_information = {
  type: 'individual',
  document: '',
  name: '',
  email: '',
  phone_numbers: [
    {
      ddd: '',
      number: '',
      type: ''
    }
  ],
  site_url: '',
  company_name: '',
  trading_name: '',
  annual_revenue: '',
  founding_date: '',
  address: {
    street: '',
    complement: '',
    number: '',
    neighborhood: '',
    city: '',
    state: '',
    zip_code: '',
    reference_point: ''
  },
  managing_partners: []
}

export const managing_partner = {
  name: '',
  email: '',
  document: '',
  type: 'individual',
  mother_name: '',
  birth_date: '',
  monthly_income: 0,
  professional_occupation: '',
  self_declared_legal_representative: false,
  address: {
    street: '',
    complement: '',
    number: '',
    neighborhood: '',
    city: '',
    state: '',
    zip_code: '',
    reference_point: ''
  },
  phone_numbers: [
    {
      ddd: '',
      number: '',
      type: ''
    }
  ]
}
